import { ISmStates } from './sm.types';
import conditions from './conditions';
import states from './states';
import transitions from './transitions/default/transitions';
import MNtransitions from './transitions/MN/transitions';
import STATES, { IEX_STATE_CODES } from '../../../constants/configs/states';

export default (stateCode:IEX_STATE_CODES) => {
    // smConditions and smStates are shared across all states.
    // smTransitions are state specific.
    let result: ISmStates = {
        states: states,
        conditions: conditions,
        transitions,
    };

    switch (stateCode) {
        case STATES.MINNESOTA: {
            result.transitions = MNtransitions;
            break;
        }
        default: {
            result.transitions = transitions;
        }
    }

    return result;
};
